import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { getMasterHealthPlan } from "../../../actions/Master";
import { checkEligibility, getHealthPlanDetailsByBenefitPlanUid, information, patientInformationById, saveMemberInfo } from "../../../actions/Patient";
import { EligibilityCheck, GetPatientInformationPayload, MemberInfoData, SaveInformation } from "../../../models/Patient";
import { getListResult } from "../../../utils";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { ReAuthTabData } from "../../../models/TabSessionStorage";
import { saveTabSessionReAuthStorageResp } from "../../../actions/TabSessionStorage";
import ReAuthWorkFlow from "../components";
import { getReAuthDefaultServiceProvider, getReAuthReferralData } from "../../../actions/ReferralAction";

const mapStateToProps = ({
  healthPlanState,
  checkEligibilityState,
  tabSessionStorageReAuthState,
  patientFromMbiState,
  benefitPlanUidState,
  loggedInUserState,
  patientInformationByIdState,
  informationState,
  reAuthDefaultValueState,
  reAuthReferralDetailState,
  memberInfoDataState,
  samlResponseState,
}: ApplicationState) => ({
  healthPlanState: getListResult(healthPlanState.response),
  checkEligibilityData: checkEligibilityState,
  tabSessionStorage: tabSessionStorageReAuthState.response,
  patientFromMbiState: patientFromMbiState.response,
  benefitPlanUidState: benefitPlanUidState.response,
  loggedInUserState: loggedInUserState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  informationState: informationState.response,
  informationErrorState: informationState.error,
  reAuthDefaultValueState: reAuthDefaultValueState.response,
  reAuthReferralDetailState: reAuthReferralDetailState.response,
  memberInfoDataState: memberInfoDataState.response,
  samlResponseState: getSamlResponse(samlResponseState),
});

const getSamlResponse = (samlResponseState: any) => {
  return samlResponseState.response
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    saveTabSessionStorage: (sessionData: ReAuthTabData) => {
      dispatch(saveTabSessionReAuthStorageResp(sessionData));
    },
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
    getMasterHealthPlan: () => {
      dispatch(getMasterHealthPlan());
    },
    checkEligibility: (payload: EligibilityCheck) => {
      dispatch(checkEligibility(payload));
    },
    getReAuthReferralData: (referralId: number) => {
      dispatch(getReAuthReferralData(referralId));
    },
    getReAuthDefaultServiceProvider: (providerId: number) => {
      dispatch(getReAuthDefaultServiceProvider(providerId));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    getHealthPlanDetailsByBenefitPlanUid: (benefitPlanUid: string) => {
      dispatch(getHealthPlanDetailsByBenefitPlanUid(benefitPlanUid));
    },
    getPatientInformationById: (payload: GetPatientInformationPayload) => {
      dispatch(patientInformationById(payload));
    },
    information: (payload: SaveInformation) => {
      dispatch(information(payload));
    },
    saveMemberInfo: (payload: MemberInfoData) => {
      dispatch(saveMemberInfo(payload));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReAuthWorkFlow);
